"use strict";

jQuery(document).ready(function ($) {
  // Simple accordion functionality
  $('.accordion__group button').on('click', function (e) {
    e.preventDefault();

    // If item clicked on is open, close it
    if ($(this).closest('.accordion__group').hasClass('active')) {
      $(this).closest('.accordion__group').removeClass('active');
      $(this).closest('.accordion__group').find('.accordion__copy').slideUp();
    } else {
      // Otherwise, close all others and open the one clicked on
      $('.accordion__group').removeClass('active');
      $('.accordion__copy').slideUp();
      $(this).closest('.accordion__group').addClass('active');
      $(this).closest('.accordion__group').find('.accordion__copy').slideToggle();
    }
  });
});
"use strict";

jQuery(document).ready(function ($) {
  /******************************************
    QTY Selector ( Simple quantity box increase / decrease )
   ******************************************/

  // PDP / PLP
  $('.js-qty:not(.js-qty--cart)').on('click', function (e) {
    e.preventDefault();
    var $this = $(this);
    var $parent = $this.parent();
    var qtyInput = $parent.find('input');
    var qtyInputVal = qtyInput.val();
    qtyInputVal = $.isNumeric(qtyInputVal) ? qtyInputVal : 1;
    if ($this.hasClass('js-qty--plus')) {
      qtyInputVal++;
      qtyInputVal = qtyInputVal < 1 ? 1 : qtyInputVal;
    } else {
      qtyInputVal--;
      qtyInputVal = qtyInputVal < 1 ? 1 : qtyInputVal;
    }
    qtyInput.val(qtyInputVal);
  });
  $('body').on('click', '.product--default .btn--atc', function () {
    var id = $(this).attr('data-id');
    CartJS.addItem(parseInt(id), 1, {}, {
      success: function (data, textStatus, jqXHR) {
        jQuery.getJSON('/cart.js', function (cart) {
          // refreshMiniCart(cart);
          window.location.href = '/cart';
        });
      },
      error: function (jqXHR, textStatus, errorThrown) {
        //error state
        console.log('Error: ' + errorThrown + '!');
      }
    });
  });

  // MAIN CART

  // Allow typing of input qty for update
  var timer;
  $('.col__qty, .mobile-stuff').on('keyup', '.qty input', function () {
    var $this = $(this);
    var newVal = $this.val();
    var lineNum = $this.closest('.cart-row').attr('data-linenum');

    // clear the previous timer
    clearTimeout(timer);

    // create a new timer with a delay of 300ms seconds,
    // if the keyup is fired before the 300ms secs then the timer will be cleared
    timer = setTimeout(function () {
      // this will be executed if there is a gap of 300ms seconds between 2 keyup events
      CartJS.updateItem(lineNum, newVal, {}, {
        success: function (data, textStatus, jqXHR) {
          location.reload();
        },
        error: function (jqXHR, textStatus, errorThrown) {
          console.log(errorThrown);
        }
      });
    }, 300);
  });
  $('.col__qty, .mobile-stuff').on('click', '.js-qty--cart', function (e) {
    e.preventDefault();
    var $this = $(this);
    var qtyInput = $this.closest('.qty').find('input');
    var qtyInputVal = qtyInput.val();
    qtyInputVal = $.isNumeric(qtyInputVal) ? qtyInputVal : 1;
    var lineNum = $this.closest('.cart-row').attr('data-linenum');
    if ($this.hasClass('js-qty--plus')) {
      qtyInputVal++;
      qtyInputVal = qtyInputVal < 1 ? 1 : qtyInputVal;
    } else {
      qtyInputVal--;
      // qtyInputVal = qtyInputVal < 1 ? 1 : qtyInputVal;
    }
    if (qtyInputVal >= 1) {
      CartJS.updateItem(lineNum, qtyInputVal, {}, {
        success: function (data, textStatus, jqXHR) {
          location.reload();
        },
        error: function (jqXHR, textStatus, errorThrown) {
          console.log(errorThrown);
        }
      });
    } else {
      CartJS.removeItem(lineNum, {
        success: function (data, textStatus, jqXHR) {
          location.reload();
        },
        error: function (jqXHR, textStatus, errorThrown) {
          console.log(errorThrown);
        }
      });
    }
  });

  // MAIN CART REMOVE
  $('.actions .remove-product').on('click', function (e) {
    e.preventDefault();
    var $this = $(this);
    var lineNum = $this.closest('.cart-row').attr('data-linenum');
    CartJS.removeItem(lineNum, {
      success: function (data, textStatus, jqXHR) {
        location.reload();
      },
      error: function (jqXHR, textStatus, errorThrown) {}
    });
  });

  /******************************************
    Options to change SM-RC Widget dropdowns
   ******************************************/

  // SELECT TYPE
  $('.option__wrap select').on('change', function () {
    var optionVal = $(this).val();
    var optionNum = $(this).closest('.option__wrap').attr('data-option');
    $('select[' + optionNum + ']').val(optionVal).change();
  });

  // BUTTON TYPE
  $('.option__wrap button').on('click', function (e) {
    var optionVal = $(this).attr('data-val');
    var optionNum = $(this).closest('.option__wrap').attr('data-option');

    // Set visual display of active
    $(this).closest('.option__wrap').find('button').removeClass('active');
    $(this).addClass('active');
    $('select[' + optionNum + ']').val(optionVal).change();
  });

  // RECHARE WIDGET VARIANTS
  $('.pdp__recharge input').on('click', function () {
    if ($(this).val() == 'rc-yes') {
      $('.form__group--rc').show();
      var planId = $(this).closest('.pdp__recharge').find('.frequency-select').val();
      $('[sm-rc-plan-selector]').val(planId).change();
    } else {
      $('.form__group--rc').hide();
      $('[sm-rc-plan-selector]').val('false').change();
    }
  });

  // RECHARE WIDGET SUBSCRIPTION PLAN
  $('.template__product .frequency-select').on('change', function () {
    var planId = $(this).val();
    $('[sm-rc-plan-selector]').val(planId).change();
  });
});
"use strict";

jQuery(function () {
  /* Hero Banner SLider */
  if (typeof Swiper !== "undefined") {
    var heroSlider = new Swiper(".js__hero-banner-slider", {
      slidesPerView: 1,
      /*autoHeight: true,*/
      resistance: false,
      loop: true,
      spaceBetween: 0,
      // autoplay: {
      //     delay: 10000,
      // },
      // Navigation arrows
      navigation: {
        nextEl: ".swiper-button-next-hero-banner",
        prevEl: ".swiper-button-prev-hero-banner"
      }
    });

    /* Quote SLider */
    var quoteSlider = new Swiper(".js__full-width-quote-slider", {
      slidesPerView: 1,
      autoHeight: true,
      resistance: false,
      loop: true,
      spaceBetween: 20,
      // Navigation arrows
      pagination: {
        el: ".swiper-pagination-quote",
        clickable: true
      }
    });

    /* full width Card SLider */
    var cardSlider = new Swiper(".js__full-width-cards-slider", {
      slidesPerView: 'auto',
      autoHeight: true,
      resistance: false,
      loop: true,
      spaceBetween: 10,
      centeredSlides: true,
      autoplay: {
        delay: 2000
      },
      breakpoints: {
        768: {
          slidesPerView: 3,
          spaceBetween: 20
        }
      },
      // Navigation arrows
      navigation: {
        nextEl: ".swiper-button-next-card",
        prevEl: ".swiper-button-prev-card"
      }
    });

    /* full width Card SLider */
    var iconSlider = new Swiper(".js__icon-small-card-slider", {
      slidesPerView: 5,
      autoHeight: true,
      resistance: false,
      loop: true,
      spaceBetween: 0,
      centeredSlides: true,
      speed: 5000,
      autoplay: {
        delay: 1
      }
      // breakpoints: {
      //     768: {
      //         slidesPerView: 3,
      //         spaceBetween: 20
      //     }
      // },
      // Navigation arrows
      // navigation: {
      //     nextEl: ".swiper-button-next-card",
      //     prevEl: ".swiper-button-prev-card",
      // },
    });
    var halfContentHalfProduct = new Swiper(".js_half-content-half-product", {
      slidesPerView: 1,
      autoHeight: true,
      resistance: false,
      spaceBetween: 20,
      scrollbar: {
        el: ".swiper-scrollbar"
      },
      navigation: {
        nextEl: ".swiper-button-next-product",
        prevEl: ".swiper-button-prev-product"
      }
    });

    // Product Recommendation
    var producrSlider = new Swiper('.js__pdp-recommendation-slider', {
      slidesPerView: 4,
      loop: true,
      allowTouchMove: true,
      shortSwipes: true,
      spaceBetween: 20,
      threshold: 1,
      // Navigation arrows
      navigation: {
        nextEl: '.swiper-button-next-product-recommed',
        prevEl: '.swiper-button-prev-product-recommed'
      },
      breakpoints: {
        0: {
          slidesPerView: 1,
          spaceBetween: 20
        },
        481: {
          slidesPerView: 2,
          spaceBetween: 20
        },
        769: {
          slidesPerView: 3,
          spaceBetween: 20
        },
        981: {
          slidesPerView: 4,
          spaceBetween: 20
        }
      }
    });
  }

  /* Collection selected*/
  $(document).ready(function ($) {
    $(".js__collections-select").change(function () {
      window.location = $(this).val();
    });

    /*Dropdown selected*/
    $(".js__collection-content li").each(function (index) {
      var value = $(this).attr("data-url").toLowerCase();
      if (window.location.href.toLowerCase().indexOf(value) > -1) {
        $(this).addClass("active");
        $(".js__collections-select").val($(this).attr("data-url"));
      }
    });
  });
  try {
    var pageTotal = parseInt($(".js__total-page").val());
    var currentPage = parseInt($(".js__current-page").val());
    var itemTotal = parseInt($(".js__items-count").val());
    var perPageItem = parseInt($(".js__perpage-item").val());
    var itemStart = 1;
    var itemEnd = 0;
    if (currentPage > 1) {
      itemStart = perPageItem * (currentPage - 1) + 1;
    }
    itemEnd = itemStart + perPageItem - 1;
    if (pageTotal == currentPage) {
      itemEnd = itemTotal;
    }
    $(".js__page-range").html(itemStart + " - " + itemEnd);
  } catch {}

  /* SLIDER */

  /* PDP
  Tab working */
  $(".tab-link").on("click", function () {
    var dataId = $(this).attr("data-attr");
    var i, tabcontent, tablink;
    tabcontent = document.getElementsByClassName("tab-content");
    for (i = 0; i < tabcontent.length; i++) {
      tabcontent[i].style.display = "none";
    }
    tablink = document.getElementsByClassName("tab-link");
    for (i = 0; i < tablink.length; i++) {
      tablink[i].className = tablink[i].className.replace(" active", "");
    }
    document.getElementById(dataId).style.display = "block";
    event.currentTarget.className += " active";

    /*PDP select*/
    $(".js__pdp-tab-select").val(dataId);
  });

  /* GLOBAL
  Scroll to particular Div with # value */
  $('a[href^="#"]').on("click", function (event) {
    var target = $(this.getAttribute("href"));
    if (target.length) {
      event.preventDefault();
      $(".tab-head").hide();
      $("html, body").stop().animate({
        scrollTop: target.offset().top - 150
      }, 1000);
    }
  });
  // $(".js__accordian").children("li:first-child").addClass("active");
  /* accordion working about content in small screen*/
  $(".js__accordian").children("li").children("h5,h6,h3,.h5,h2").click(function (e) {
    if ($(this).parent("li").children(".content").css("display") == "none") {
      $(this).parent("li").parent(".js__accordian").children("li").children(".content").hide();
      $(this).parent("li").parent(".js__accordian").children("li").removeClass("active");
      $(this).parent("li").children(".content").slideDown();
      $(this).parent("li").addClass("active");
      /* $('html,body').animate({
        scrollTop: $(this).offset().top - 120
      }, 500);*/
    } else {
      $(this).parent("li").children(".content").slideUp();
      $(this).parent("li").removeClass("active");
    }
  });

  /* Accordion working when we have multiple content*/

  $(".js__accordians").children("li").attr("aria-expanded", false);
  $(".js__accordians").children("li").children("h5,h6,h3,h4").attr("role", "button");
  $(".js__accordians").children("li").children("h5,h6,h3,h4").attr("tabindex", "0");
  $(".js__accordians").children("li").children("h5,h6,h3,h4").click(function (e) {
    var type = $(this).parent("li").attr("data-attr");
    if ($("." + type).css("display") == "none") {
      $(this).attr("aria-expanded", true);
      $(this).parent("li").parent(".js__accordians").children(".content").hide();
      $(this).parent("li").parent(".js__accordians").children("li").removeClass("active");
      $("." + type).slideDown();
      $(this).parent("li").addClass("active");
      $(this).addClass("active");
    } else {
      $(this).attr("aria-expanded", false);
      $(this).parent("li").removeClass("active");
      $("." + type).slideUp();
      $(this).removeClass("active");
    }
  });
  $(".js__accordians").children("li").children("h5,h6,h3,h4").keypress(function (e) {
    if (e.which == 13) {
      var type = $(this).parent("li").attr("data-attr");
      if ($("." + type).css("display") == "none") {
        $(this).attr("aria-expanded", true);
        $(this).parent("li").parent(".js__accordians").children(".content").hide();
        $(this).parent("li").parent(".js__accordians").children("li").removeClass("active");
        $("." + type).slideDown();
        $(this).parent("li").addClass("active");
        $(this).addClass("active");
      } else {
        $(this).attr("aria-expanded", false);
        $(this).parent("li").removeClass("active");
        $("." + type).slideUp();
        $(this).removeClass("active");
      }
    }
  });
  /*Image accordian*/
  $(".js__image-accordian .title").on("click", function () {
    if ($(this).parent("li").children(".content").css("display") == "none") {
      $(this).parent("li").children(".content").slideDown(300);
      $(this).parent("li").addClass("active");
    } else {
      $(this).parent("li").removeClass("active");
      $(this).parent("li").children(".content").slideUp(300);
    }
  });
});

/** Dropdown **/
jQuery(function ($) {
  $(".js__dropdown_result").on("click", function () {
    if ($(".js__dropdown").css("display") == "none") {
      $(".js__dropdown").slideDown(300);
    } else {
      $(".js__dropdown").slideUp(300);
    }
    $(this).toggleClass("active");
  });
  var path = window.location.href; // because the 'href' property of the DOM element is the absolute path
  $(".js__dropdown li a").each(function () {
    if (this.href === path) {
      $(this).addClass("active");
      console.log($(this).html());
      if ($(this).html() != "view all") {
        $(".js__dropdown_result").html($(this).html());
      }
      $(".js__dropdown").slideUp(300);
      $(".js__dropdown_result").removeClass("active");
    }
  });
  $(".js__active-class li a").each(function () {
    if (this.href === path) {
      $(".js__active-class li a").removeClass("active");
      $(this).addClass("active");
    }
  });
});
/* Mini cart - Checkout Button visiblity fix for IOS Mobile */
var lastScroll = 0;
jQuery(document).ready(function ($) {
  $(".cart-sidebar__middle").addClass("safari-mobile");
  $(window).scroll(function () {
    var scroll = $(window).scrollTop();
    if (scroll > lastScroll) {
      $(".cart-sidebar__middle").removeClass("safari-mobile");
    } else if (scroll < lastScroll) {
      $(".cart-sidebar__middle").addClass("safari-mobile");
    }
    lastScroll = scroll;
  });
});

/** Dropdown **/
jQuery(function ($) {
  /*Blog dropdown*/
  $(".js__blog-select").change(function () {
    window.location = $(this).val();
  });
  /*Dropdown selected*/
  $(".js__blog-select option").each(function (index) {
    var value = $(this).val().toLowerCase();
    if (window.location.href.toLowerCase().indexOf(value) > -1) {
      $(".js__blog-select").val($(this).val());
    }
  });
});
jQuery(function ($) {
  $(".js--open-rates-popup").on("click", function () {
    $(".js__rates-popup").show();
  });
  $(".js__modal-close").on("click", function () {
    $(".modal").hide();
  });
});

/*First tab link and first tab content active */
jQuery(document).ready(function ($) {
  $(".tab-link").first().addClass("active");
  $(".shopify-section .tab-content").first().show();
});

/*Select Dropdown change wit Tab */
jQuery(function () {
  var path = window.location.href; // because the 'href' property of the DOM element is the absolute path
  $(".dropdown-select option").each(function () {
    if (this.value.toLowerCase() == path.toLowerCase()) {
      this.setAttribute("selected", true);
    }
  });
  $(".dropdown-select").change(function () {
    var dropdown = $(".dropdown-select").val();
    //first hide all tabs again when a new option is selected
    $(".tab-content").hide();
    //then show the tab content of whatever option value was selected
    $("#" + "tab-" + dropdown).show();
  });
});
/*Blog content checking if p tag has image then adding class*/

jQuery(function () {
  $(".article-content p").each(function (index) {
    if ($(this).html().indexOf("<img") > -1) {
      // console.log(vaar);
      $(this).addClass("full-width");
    }
    if ($(this).html().indexOf("<iframe") > -1) {
      $(this).addClass("full-width");
    }
  });
});
jQuery(function () {
  $(".full-format p").each(function (index) {
    if ($(this).html().indexOf("<img") > -1) {
      // console.log(vaar);
      $(this).addClass("full-width");
    }
    if ($(this).html().indexOf("<iframe") > -1) {
      $(this).addClass("full-width");
    }
  });
});
jQuery(function () {
  $(".full-format").children("div").each(function (index) {
    if ($(this).html().indexOf("<img") > -1) {
      // console.log(vaar);
      $(this).addClass("full-width");
    }
    if ($(this).html().indexOf("<iframe") > -1) {
      $(this).addClass("full-width");
    }
  });
});
// jQuery(document).ready(function ($) {
//     // Get the element
//     for (var i = 0; i < 250; i++) {
//       var marqueeFooter = document.querySelector('.js__marquee-right .repeat');
//       // Create a copy of it
//       var cloneFooter = marqueeFooter.cloneNode(true);
//       // Inject it into the DOM
//       marqueeFooter.before(cloneFooter);
//     }
//   });
// Footer dropdown
(function ($) {
  $(function () {
    var navLink = false;
    $(".js__toggle-footer-link").on("mousedown", function (e) {
      "use strict";

      e.stopImmediatePropagation();
      if ($(window).width() < 981) {
        if ($(this).hasClass("active")) {
          $(this).removeClass("active");
          $(this).siblings(".js__footer-menu-content").slideUp(300);
        } else {
          $(".js__toggle-footer-link").removeClass("active");
          $(this).addClass("active");
          $(".js__footer-menu-content").slideUp(300);
          $(this).siblings(".js__footer-menu-content").slideDown(300);
        }
      }
      navLink = true;
    });
  });
})(jQuery);
"use strict";

jQuery(function () {
  /* Footer - Accordion Visiblity */
  if (getglobalLib("Footer_Accordion") == "yes") {
    $(".js__accordion-toggle-visiblity").addClass("accordion-toggle-footer");
    $(".js__accordion-content-visiblity").addClass("accordion-content-footer");
  }
  /* FAQ - Category Sidebar Visiblity */
  if (getglobalLib("FAQ_Side_Panel") == "yes") {
    $(".js__faq-category-side-panel").removeClass("hide");
  }
});
"use strict";

jQuery(function () {
  /* Global
  Announcement Slider */
  if (typeof Swiper !== "undefined") {
    var announcementSlider = new Swiper(".js__announcement-slider", {
      slidesPerView: 1,
      resistance: false,
      shortSwipes: true,
      loop: false,
      autoHeight: true,
      autoplay: {
        delay: 3000
      },
      direction: 'vertical'
    });
  }
  if (!$("div").hasClass("announcement-bar")) {
    $(".main-content").addClass("padding-0");
  }
  // if ($(this).parent("li").children(".content").css("display") == "none")
  if ($("body").find(".announcement-bar").css("display") == "none") {
    $(".main-content").addClass("padding-0");
  }
  /* Announcement 
     /* Announcement 
    Close on Click  */
  var announcementCloseCookie = typeof readCookie === "function" ? readCookie("announcementClose") : null;
  // console.log("announcementCloseCookie" + announcementCloseCookie)
  if (announcementCloseCookie == "Yes") {
    $(".announcement-bar").hide();
    $("body").removeClass("announcement-visible");
    $(".main-content").addClass("active");
    $("#navbarNavDropdown").addClass("announce-hidden");
  }
  $("#announcement-close").on("click", function () {
    $(".announcement-bar").hide();
    $("body").removeClass("announcement-visible");
    $(".main-content").addClass("active");
    $("#navbarNavDropdown").addClass("announce-hidden");
    createCookie("announcementClose", "Yes", '1');
  });

  /* Close on Click  */

  if ($("div").hasClass("hero-banner") || $("div").hasClass("error-page") || $("div").hasClass("inner-hero-section")) {
    $("body").addClass("transparent-header");
    $(".main-content").addClass("padding-0");
  } else {
    $("body").removeClass("transparent-header");
    $(".main-content").removeClass("padding-0");
  }

  /* MEGAMENU
    active link while submenu open */
  if ($(window).width() > 980) {
    $('.has-sub-nav').hover(function (event) {
      event.stopPropagation(); // Stop event propagation
      // Adding a extra link to give anchor hover effect
      $(this).children(".site-nav__link").addClass("hover-submenu");
      // Give Visibility and opacity to the Sub nav menu
      $(this).children(".sub-nav").css("visibility", "visible");
      $(this).children(".sub-nav").css("opacity", "1");
      $(this).children(".sub-nav").css("z-index", "20");

      // Remove transparent header from index page when sub menu open
      $("body").removeClass("transparent-header");
    }, function (event) {
      event.stopPropagation(); // Stop event propagation
      // Remove  extra link to remove anchor hover effect
      $(this).children(".site-nav__link").removeClass("hover-submenu");
      $(".has-sub-nav").children(".site-nav__link").removeClass("hover-submenu");
      // Remove Visibility and opacity from the Sub nav menu
      $(".has-sub-nav").children(".sub-nav").css("visibility", "hidden");
      $(".has-sub-nav").children(".sub-nav").css("opacity", "0");
      $(this).children(".sub-nav").css("z-index", "20");
      if ($("body").hasClass("fixed-header")) {
        $("body").removeClass("transparent-header");
      } else {
        // $("body").addClass("transparent-header");
        if ($(this).children(".site-nav__link").hasClass("hover-submenu")) {
          $("body").removeClass("transparent-header");
        } else {
          if ($("div").hasClass("hero-banner") || $("div").hasClass("error-page") || $("div").hasClass("inner-hero-section")) {
            $("body").addClass("transparent-header");
          }
        }
      }
      // Add transparent header from index page when sub menu open
      // $(".template-index").addClass("transparent-header");
    });
    $('.has-big-nav').hover(function (event) {
      event.stopPropagation();
      $(this).children(".site-nav__link").addClass("hover-submenu");
      $("body").addClass("nav-menu-open");
    }, function (event) {
      event.stopPropagation();
      $(this).children(".site-nav__link").removeClass("hover-submenu");
      $("body").removeClass("nav-menu-open");
    });
  }

  //  Sub Menu in MObile
  /* SubMenu
     Accordion JS */
  function toggleAccordionItem($toggle, contentSel, toggleSel) {
    if ($toggle.parent("div").hasClass("footer-links") && $(window).width() >= 981) {
      return;
    }
    if ($toggle.hasClass("active")) {
      $toggle.removeClass("active");
      $toggle.siblings(contentSel).slideUp(300);
    } else {
      $(toggleSel).not($toggle).removeClass("active");
      $(contentSel).not($toggle.siblings(contentSel)).slideUp(300);
      $toggle.addClass("active");
      $toggle.siblings(contentSel).slideDown(300);
    }
  }
  $(document).off("click.mobileAccordion", ".accordion-toggle").on("click.mobileAccordion", ".accordion-toggle", function (e) {
    e.preventDefault();
    e.stopPropagation();
    toggleAccordionItem($(this), ".accordion-content", ".accordion-toggle");
  });
  $(document).off("click.mobileAccordionInner", ".accordion-toggle-inner").on("click.mobileAccordionInner", ".accordion-toggle-inner", function (e) {
    e.preventDefault();
    e.stopPropagation();
    toggleAccordionItem($(this), ".accordion-content-inner", ".accordion-toggle-inner");
  });
});

/** Fix Header on Scroll **/
$(window).scroll(function () {
  var sticky = $("header"),
    scroll = $(window).scrollTop();
  if (scroll >= 34) {
    sticky.addClass("fixed");
    $(".main-content").addClass("active");
    var newsHeight = $('.announcement-bar').height();
    $('.announcement-bar').css("margin-top", '-' + newsHeight + 'px');
    var paddingtop = 85 - newsHeight;
    // $(".main-content").css("padding-top",'85' + newsHeight + 'px');
    $("body").addClass("fixed-header");
    $("body").removeClass("transparent-header");
  } else {
    sticky.removeClass("fixed");
    if ($('.announcement-bar').is(':hidden')) {
      $(".main-content").addClass("active");
      $("#navbarNavDropdown").addClass("announce-hidden");
    } else {
      $(".main-content").removeClass("active");
    }
    $('.announcement-bar').css("margin-top", '0px');
    $("body").removeClass("fixed-header");
    if ($("#navbarNavDropdown").hasClass("active")) {
      $("body").removeClass("transparent-header");
    } else {
      if ($("div").hasClass("hero-banner") || $("div").hasClass("error-page") || $("div").hasClass("inner-hero-section")) {
        $("body").addClass("transparent-header");
      } else {
        $("body").removeClass("transparent-header");
      }
    }
    if ($(".has-big-nav").children(".site-nav__link").hasClass("hover-submenu")) {
      $("body").removeClass("transparent-header");
    }
    if ($(".has-sub-nav").children(".site-nav__link").hasClass("hover-submenu")) {
      $("body").removeClass("transparent-header");
    }
  }
});
/** used when header is relative **/
/** Fix Header on Scroll **/
document.addEventListener("DOMContentLoaded", function () {
  window.addEventListener("scroll", function () {
    var scrollHeight = 33;
    if (window.scrollY > scrollHeight) {
      document.getElementById("navbarNavDropdown").classList.add("fixed");
      // add padding top to show content behind navbar
      var navbar_height = document.querySelector(".navbar-collapse").offsetHeight;
      document.body.style.paddingTop = navbar_height + "px";
    } else {
      document.getElementById("navbarNavDropdown").classList.remove("fixed");
      // remove padding top from body
      document.body.style.paddingTop = "0";
    }
  });
});

/** Mobile Navigation Open Close **/
$(document).on("click", "#hamburger", function (e) {
  e.preventDefault();
  e.stopPropagation();
  $(this).toggleClass("active");
  $("#navbarNavDropdown").toggleClass("active");
  $(".js__mobile-menu-open-hide").toggleClass("active");
  $(".js__mobile-announcement-text").toggleClass("active");
  $("body").toggleClass("mobile-nav-open", $("#navbarNavDropdown").hasClass("active"));
  $("body").removeClass("transparent-header");
  if ($("#navbarNavDropdown").hasClass("active")) {
    $(".js__logo").addClass("active");
  } else {
    $(".js__logo").removeClass("active");
    if ($("body").hasClass("fixed-header")) {
      $("body").removeClass("transparent-header");
    }
  }
});
// if ($(window).width() > 981) {
//   // $("html").css("overflow-y","hidden");
//   $("html").removeClass("scroll-stop");
// }
/** CART SIDEBAR
 * Close on Outside Click
 * **/
$(document).mouseup(function (e) {
  var popup = $("#CartSidebar");
  var overlay = $("#cart_overlay");
  if (!popup.is(e.target) && popup.has(e.target).length == 0) {
    popup.removeClass("active");
    overlay.removeClass("active");
  }
});
// jQuery(document).ready(function($) {

//     // Close mini cart
//     $('.mini-cart__bg, .mini-cart__content .close').on('click', function() {
//         closeMini();
//     });

//     // Show mini cart
//     $('header .icon--cart').on('click', function(e) {
//         e.preventDefault();

//         if (!$('body').hasClass('template__cart')) {
//             showMini();
//         } else {
//             e.preventDefault();
//         }
//     });

//     // Mini Cart Remove Product
//     $('.mini-cart').on('click', '.remove-product', function() {
//         var lineNum = $(this).closest('.product').attr('data-lineid');
//         $(this).closest('.product').addClass('removed');

//         CartJS.removeItem(lineNum, {
//             success: function(data, textStatus, jqXHR) {
//                 jQuery.getJSON('/cart.js', function(cart) {
//                     refreshMiniCart(cart);
//                 });
//             },
//             error: function(jqXHR, textStatus, errorThrown) {
//                 console.log(errorThrown);
//             }
//         })
//     });

//     // Mini Cart Upsell ATC
//     $('.mini-cart__upsell .action--atc').on('click', function(e) {
//         e.preventDefault();

//         var dataId = $(this).closest('.upsell').attr('data-id');

//         CartJS.addItem(dataId, 1, {}, {
//             success: function(data, textStatus, jqXHR) {
//                 jQuery.getJSON('/cart.js', function(cart) {
//                     refreshMiniCart(cart);
//                 });
//             },
//             error: function(jqXHR, textStatus, errorThrown) {
//                 console.log(errorThrown);
//             }
//         })
//     })

//     // Mini Cart Qty
//     $('.mini-cart__list').on('click', '.js-qty--mini', function(e) {
//         e.preventDefault();

//         var $this = $(this);
//         var $parent = $this.parent();
//         var qtyInput = $parent.find('input');
//         var qtyInputVal = qtyInput.val();
//         qtyInputVal = $.isNumeric(qtyInputVal) ? qtyInputVal : 0;
//         var lineData = $this.closest('.product').data('lineid');
//         var lineNum = $('[data-lineID="' + lineData + '"]').index();

//         if ($this.hasClass('js-qty--plus')) {
//             qtyInputVal++;
//             qtyInputVal = qtyInputVal < 0 ? 1 : qtyInputVal;
//         } else {
//             qtyInputVal--;
//             qtyInputVal = qtyInputVal < 1 ? 1 : qtyInputVal;
//         }

//         CartJS.updateItem((lineNum + 1), qtyInputVal, {}, {
//             success: function(data, textStatus, jqXHR) {
//                 jQuery.getJSON('/cart.js', function(cart) {
//                     refreshMiniCart(cart);
//                 });
//             },
//             error: function(jqXHR, textStatus, errorThrown) {
//                 console.log(errorThrown);
//             },
//         });
//     });

//     // Allow typing of input qty for update
//     var timer;
//     $('.mini-cart__list').on('keyup', '.actions .qty-val', function() {
//         var $this = $(this);
//         var newVal = $this.val();
//         var lineData = $this.closest('.product').data('lineid');

//         // clear the previous timer
//         clearTimeout(timer);

//         // create a new timer with a delay of 300ms seconds,
//         // if the keyup is fired before the 300ms secs then the timer will be cleared
//         timer = setTimeout(function() {
//             // this will be executed if there is a gap of 300ms seconds between 2 keyup events
//             console.log(newVal);
//             CartJS.updateItem(lineData, newVal, {}, {
//                 success: function(data, textStatus, jqXHR) {
//                     jQuery.getJSON('/cart.js', function(cart) {
//                         refreshMiniCart(cart);
//                     });
//                 },
//                 error: function(jqXHR, textStatus, errorThrown) {
//                     console.log(errorThrown);
//                 },
//             });
//         }, 300);
//     });
// });

// function closeMini() {
//     $('body').removeClass('cart-open');
//     $('.mini-cart').removeClass('is-open');
//     $('.mini-cart').fadeOut('fast');
// }

// function showMini() {
//     $('body').addClass('cart-open');
//     $('.mini-cart').fadeIn('fast');
//     $('.mini-cart').addClass('is-open');

//     // Set height of product list for full-height mini-cart
//     // var miniHead = parseInt( $( '.mini-cart__header' ).innerHeight() );
//     // var miniShip = parseInt( $( '.mini-cart__ship' ).innerHeight() );
//     // var miniFooter = parseInt( $( '.mini-cart__footer' ).innerHeight() );
//     // var miniUp = parseInt( $( '.mini-cart__upsell' ).innerHeight() );
//     // var miniTotalHeight = miniHead + miniShip + miniFooter + miniUp;
// }

// function refreshMiniCart(cartData) {
//     var cartItems = cartData.items;
//     var newCartHtml = '';

//     // Free shipping updater
//     var totalShip = parseInt($('.mini-cart').data('freeship'));
//     var newCartTotal = cartData.items_subtotal_price;
//     var awayShip = totalShip - newCartTotal;
//     var shipPercent = (newCartTotal / totalShip) * 100;

//     if (shipPercent >= 100) {
//         $('.shipping-bar--progress').css('width', '100%');
//         $('.mini-cart__ship').addClass('is-free');
//     } else {
//         if ($('.mini-cart__ship').hasClass('is-free')) {
//             $('.mini-cart__ship').removeClass('is-free')
//         }
//         $('.free-count').text(formatter.format(awayShip / 100));
//         $('.shipping-bar--progress').css('width', shipPercent + '%');
//     }

//     // If cart is now empty
//     if (cartData.item_count == 0) {
//         newCartHtml += ' <h3 class="text-center">Cart is empty</h3>';
//     } else {

//         // Build html of new products in cart
//         $.each(cartItems, function(index, item) {
//             // Opening
//             newCartHtml += '<div class="product product--cart d-flex justify-between" data-lineid="' + (index + 1) + '">';

//             newCartHtml += ' <div class="product__image">';
//             if (item.featured_image) {
//                 newCartHtml += '<a href="' + item.url + '">';
//                 newCartHtml += '<img src="' + item.featured_image.url.replace('.jpg', '_80x.jpg').replace('.png', '_80x.png') + '" srcset="' + item.featured_image.url.replace('.jpg', '_160x.jpg').replace('.png', '_160x.png') + ' 2x" alt="' + item.image.alt + '">';
//                 newCartHtml += '</a>';
//             }
//             newCartHtml += '</div>';
//             newCartHtml += '<div class="product__info">';
//             newCartHtml += '<div class="title d-flex">';
//             newCartHtml += '<h3 class="heading--four d-flex justify-between">'
//             newCartHtml += '<a class="no-dec trans" href="' + item.url + '">';
//             newCartHtml += item.product_title;
//             newCartHtml += '</a>';
//             newCartHtml += ' <button class="remove-product trans"><span class="sr-only">Remove</span><img src="//cdn.shopify.com/s/files/1/0506/7037/0997/t/2/assets/icon-close.svg?v=18585775398919142161649090024" alt="" /></button>';
//             newCartHtml += '</h3>'
//             if (item.options_with_values != null && item.options_with_values[0].name != 'Title') {

//                 $.each(item.options_with_values, function(index, value) {
//                     console.log('index:' + index);
//                     console.log('value:' + value);
//                     newCartHtml += '<div class="var">';
//                     newCartHtml += '<span>' + item.options_with_values[index].name + ': ' + item.options_with_values[index].value + '</span>';
//                     newCartHtml += '</div>';
//                 });

//             }
//             if (item.hasOwnProperty('selling_plan_allocation')) {
//                 newCartHtml += '<span class="delivery">' + item.selling_plan_allocation.selling_plan.name + '</span>';
//             }
//             newCartHtml += '<span class="unit-price">' + formatter.format(item.price / 100) + '</span>';
//             newCartHtml += '</div>';
//             // newCartHtml += '<div class="price">'+formatter.format(item.final_line_price / 100)+'</div>';
//             newCartHtml += `<div class="actions d-flex align-center justify-between">
// 						<div class="action action--qty">
// 							<div class="qty d-flex align-center">
// 								<button class="js-qty js-qty--mini js-qty--minus trans">
// 									<span class="sr-only">Decrease</span>
// 								</button>
// 								<input sm-rc-quantity-selector type="text" value="` + item.quantity + `" min="1"  type="number" class="qty-val" />
// 								<button class="js-qty js-qty--mini js-qty--plus trans">
// 									<span class="sr-only">Increase</span>
// 								</button>
// 							</div>
// 						</div>`;
//             newCartHtml += '<div class="price">' + formatter.format(item.final_line_price / 100) + '</div>'
//             newCartHtml += '</div>';

//             // Closing
//             newCartHtml += '</div>';
//             newCartHtml += '</div>';
//         });
//     }

//     // Clear current products in cart
//     $('.mini-cart__items').empty();

//     // Set new subtotal
//     $('.mini-cart__footer .sub-total .total').text(formatter.format(cartData.total_price / 100));

//     // Set new header icon count
//     $('.icon--cart .cart-count span ').text(cartData.item_count);

//     // Add updated producst to mini cart
//     $('.mini-cart__list').html(newCartHtml);

//     // Show mini cart
//     showMini();
// }
"use strict";
"use strict";

jQuery(document).ready(function ($) {});
"use strict";

jQuery(document).ready(function ($) {
  if (typeof $.fn.slick !== "function") {
    return;
  }

  // PDP Default image slider
  $('.pdp__images--default .pdp__slider--thumb').slick({
    accessibility: false,
    infinite: true,
    arrows: true,
    dots: false,
    slidesToShow: 5,
    vertical: false,
    focusOnSelect: true,
    asNavFor: '.pdp__images--default .pdp__slider--main',
    responsive: [{
      breakpoint: 1280,
      settings: {
        slidesToShow: 4
      }
    }, {
      breakpoint: 768,
      settings: {
        slidesToShow: 4,
        vertical: false,
        arrows: false
      }
    }]
  });
  $('.pdp__images--default .pdp__slider--main').slick({
    accessibility: false,
    infinite: true,
    fade: true,
    arrows: false,
    dots: false,
    asNavFor: '.pdp__images--default .pdp__slider--thumb'
  });
  if (getglobalLib("Product_Recommendation_Slider") == "on") {
    $("#js__pdp-recommendation-slider").not(".slick-initialized").slick({
      slidesToShow: 4,
      slidesToScroll: 4,
      dots: false,
      centerMode: false,
      infinite: false,
      focusOnSelect: true,
      variableWidth: true,
      draggable: true
    });
  }
});
"use strict";

// Sleepify Starter Theme by Sleepless Media
//
// Main Javascript entry file. 

console.log('%c This site was designed & developed by https://www.sleeplessmedia.com', 'background:#000; color: #ae956e; padding: 10px 15px; font-size: 13px; font-weight: 500; width: 100%;');

// Create our number formatter.
var formatter = new Intl.NumberFormat('en-US', {
  style: 'currency',
  currency: 'USD'

  // These options are needed to round to whole numbers if that's what you want.
  //minimumFractionDigits: 0, // (this suffices for whole numbers, but will print 2500.10 as $2,500.1)
  //maximumFractionDigits: 0, // (causes 2500.99 to be printed as $2,501)
});

// Cookies functions
function setCookie(cookieName, cookieValue) {
  var today = new Date();
  var expire = new Date();
  expire.setTime(today.getTime() + 3600000 * 24 * 7);
  document.cookie = cookieName + "=" + encodeURI(cookieValue) + ";expires=" + expire.toGMTString();
}
function getCookie(cname) {
  let name = cname + "=";
  let decodedCookie = decodeURIComponent(document.cookie);
  let ca = decodedCookie.split(';');
  for (let i = 0; i < ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) == ' ') {
      c = c.substring(1);
    }
    if (c.indexOf(name) == 0) {
      return c.substring(name.length, c.length);
    }
  }
  return "";
}